import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import PropTypes from 'prop-types'
import React from 'react'
import { Button, ButtonGroup, Dropdown, DropdownButton } from 'react-bootstrap'

export function OrderFilter({ choices, onChange, disabled }) {
  const [order, setOrder] = React.useState(null)
  const current = choices.find(choice => choice[1] === order)

  React.useEffect(() => {
    onChange(order)
  }, [onChange, order])

  return (
    <div className="d-inline-block order-filter m-1">
      <ButtonGroup>
        <DropdownButton
          as={ButtonGroup}
          variant="primary"
          size="sm"
          id="range-filter"
          disabled={disabled}
          title={
            <>
              <FontAwesomeIcon
                icon={['far', 'sort']}
                fixedWidth
                className="mr-1"
              />
              SORT BY
            </>
          }
        >
          {choices.map(choice => (
            <Dropdown.Item
              key={choice[1]}
              active={order === choice[1]}
              onClick={() => setOrder(choice[1])}
            >
              {choice[0]}
            </Dropdown.Item>
          ))}
        </DropdownButton>
        {order && current && (
          <Button
            variant="secondary"
            disabled={disabled}
            size="sm"
            onClick={() => setOrder(null)}
          >
            {current[0]}
            <FontAwesomeIcon icon="times" fixedWidth className="ml-2" />
          </Button>
        )}
      </ButtonGroup>
    </div>
  )
}

OrderFilter.propTypes = {
  disabled: PropTypes.bool,
  choices: PropTypes.array,
  onChange: PropTypes.func,
}

OrderFilter.defaultProps = {
  disabled: false,
  choices: [],
  onChange: () => {},
}

export default OrderFilter
